export default __webpack_public_path__ + "static/media/whatsapp_2.ace37842.svg";